let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b5jcR")).then(() => parcelRequire('imx7a'));